import React, { useEffect, useState } from 'react';
import api from '../api/expoApi';
import OtpModal from '../components/OtpModal';

export default function RunSheetRiderView() {
    const [sheet, setSheet] = useState(null);
    const [otpItem, setOtpItem] = useState(null);
    const [msg, setMsg] = useState('');

    const load = async () => {
        try {
            const r = await api.get('/run-sheets/mine/today');
            setSheet(r.data?.data || null);
        } catch (e) { console.error(e); }
    };

    useEffect(() => { load(); }, []);

    const updateStatus = async (item, status, failure_reason = null) => {
        try {
            await api.put(`/run-sheets/${sheet.sheet_id}/items/${item.item_id}/status`,
                { status, failure_reason });
            setMsg(`Marked ${item.tracking_id} as ${status}`);
            load();
        } catch (e) { setMsg(e.response?.data?.message || 'Error'); }
    };

    const handleDeliver = (item) => {
        if (Number(item.cod_amount) > 0) {
            // Require OTP for COD delivery
            setOtpItem(item);
        } else {
            updateStatus(item, 'DELIVERED');
        }
    };

    const handleFail = (item) => {
        const reason = window.prompt('Reason for failure?');
        if (reason) updateStatus(item, 'FAILED', reason);
    };

    const onOtpVerified = () => {
        if (otpItem) updateStatus(otpItem, 'DELIVERED');
        setOtpItem(null);
    };

    if (!sheet) {
        return (
            <div style={{ padding: 24 }}>
                <h1>My Run Sheet</h1>
                <p>No active run sheet for today. Contact your supervisor.</p>
            </div>
        );
    }

    const completion = sheet.total_stops ? Math.round((sheet.completed_stops / sheet.total_stops) * 100) : 0;

    return (
        <div style={{ padding: 16, maxWidth: 600, margin: '0 auto' }}>
            <div style={{ background: '#0d6efd', color: '#fff', padding: 16, borderRadius: 8, marginBottom: 16 }}>
                <div style={{ fontSize: '.9rem', opacity: .9 }}>{sheet.route_name || 'Run Sheet'}</div>
                <div style={{ fontSize: '1.4rem', fontWeight: 700 }}>{sheet.sheet_number}</div>
                <div style={{ marginTop: 8 }}>
                    <div style={{ background: 'rgba(255,255,255,.3)', height: 8, borderRadius: 4 }}>
                        <div style={{ background: '#fff', height: 8, width: `${completion}%`, borderRadius: 4 }} />
                    </div>
                    <div style={{ fontSize: '.85rem', marginTop: 4 }}>
                        {sheet.completed_stops} / {sheet.total_stops} delivered ({completion}%)
                    </div>
                </div>
            </div>

            {msg && <div style={{ background: '#d1e7dd', padding: 8, borderRadius: 4, marginBottom: 12 }}>{msg}</div>}

            {(sheet.items || []).map((item) => (
                <div key={item.item_id} style={{
                    background: '#fff', border: '1px solid #ddd', borderRadius: 8, padding: 12, marginBottom: 8,
                    opacity: item.status !== 'PENDING' ? 0.6 : 1
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <strong>#{item.sequence}</strong>
                        <span style={{
                            padding: '2px 8px', borderRadius: 12, fontSize: '.75rem',
                            background: item.status === 'DELIVERED' ? '#198754'
                                       : item.status === 'FAILED' ? '#dc3545' : '#6c757d',
                            color: '#fff'
                        }}>{item.status}</span>
                    </div>
                    <div style={{ marginTop: 6 }}>
                        <code style={{ fontSize: '.9rem' }}>{item.tracking_id}</code>
                    </div>
                    <div style={{ fontWeight: 600 }}>{item.consignee_name}</div>
                    <div style={{ fontSize: '.85rem', color: '#666' }}>{item.consignee_phone}</div>
                    <div style={{ fontSize: '.85rem', color: '#666' }}>{item.consignee_address}</div>
                    {Number(item.cod_amount) > 0 && (
                        <div style={{ background: '#fff3cd', padding: 6, borderRadius: 4, marginTop: 6, fontWeight: 600 }}>
                            COD: PKR {Number(item.cod_amount).toLocaleString()}
                        </div>
                    )}
                    {item.status === 'PENDING' && (
                        <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                            <button onClick={() => handleDeliver(item)} style={{ flex: 1, padding: 10, background: '#198754', color: '#fff', border: 'none', borderRadius: 4 }}>
                                Deliver{Number(item.cod_amount) > 0 && ' (OTP)'}
                            </button>
                            <button onClick={() => handleFail(item)} style={{ flex: 1, padding: 10, background: '#dc3545', color: '#fff', border: 'none', borderRadius: 4 }}>
                                Fail
                            </button>
                        </div>
                    )}
                </div>
            ))}

            {otpItem && (
                <OtpModal
                    phone={otpItem.consignee_phone}
                    purpose="COD_COLLECT"
                    onVerified={onOtpVerified}
                    onCancel={() => setOtpItem(null)}
                />
            )}
        </div>
    );
}
